var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-tavolo-desktop" },
    [
      _c(
        "v-main",
        [
          _c(
            "v-row",
            { staticClass: "desktop-main-row", attrs: { "no-gutters": "" } },
            [
              _c("v-col", { attrs: { cols: _vm.svincolatiCols } }, [
                _c(
                  "div",
                  { staticClass: "asta-svincolati-desktop" },
                  [_c("asta-svincolati", { attrs: { showTitle: "" } })],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "desktop-central",
                  attrs: { cols: _vm.centralCols },
                },
                [
                  _c(
                    "div",
                    { staticClass: "asta-tavolo-desktop" },
                    [_c("asta-tavolo")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "asta-chat-messages-desktop" },
                    [_c("asta-chat-messages")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "asta-chat-input-desktop" },
                    [_c("asta-chat-input")],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-col", { attrs: { cols: "3" } }, [
                _c(
                  "div",
                  { staticClass: "asta-rose-desktop" },
                  [_c("asta-plan", { attrs: { showTitle: "" } })],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }